import React from "react";
import HomePage from "./HomePage";
import AboutAdd from "./AboutAdd";
import HomeAdd from "./HomeAdd";
const Home = () => {
  return (
    <>
      <HomePage /> {/* Corrected the component name */}
      <AboutAdd /> {/* Corrected the component name
      // <HomeAdd /> {/* Corrected the component name */} */}


    </>
  );
};

export default Home;
